import { useCallback, useEffect, useState } from 'react';
import { EventSourcePolyfill } from 'event-source-polyfill';

import { BEARER } from '@/api/api';
import { API_URL, IDocumentFilesUrlDto } from '@/dtos';
import { CONFIG } from '@/utils';
import Token from '@/utils/handlers/Token';

const getUrl = (qrId?: string) => `${CONFIG.BASE_URL}${API_URL.DOCUMENTS_RECEIPTS_FILE_BY_QR_CODES_STREAM}?qr_id=${qrId}`;

interface Props {
  qrCodeId?: string;
}

const useGetDocumentByQRCodeQuery = ({ qrCodeId }: Props) => {
  const [document, setDocument] = useState<IDocumentFilesUrlDto>();

  const handleSubscribe = useCallback(() => {
    const listener = new EventSourcePolyfill(getUrl(qrCodeId), {
      headers: {
        Authorization: `${BEARER} ${Token.getToken()}`,
      },
    });

    listener.onmessage = (event) => {
      if (!event?.data) return;

      const parsedDocument = JSON.parse(event.data) as IDocumentFilesUrlDto;

      if (parsedDocument.files?.length) {
        setDocument(parsedDocument);
      }
    };

    const dispose = () => {
      listener.close();
    };

    return dispose;
  }, [qrCodeId]);

  useEffect(() => {
    if (qrCodeId) {
      // open connection
      const dispose = handleSubscribe();

      // close connection after unmount
      return () => {
        dispose();
      };
    }
    return () => {};
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qrCodeId]);

  return {
    document,
  };
};

export default useGetDocumentByQRCodeQuery;
